/*
 * Copyright (c) 2021. American Express Company
 */

import * as H from 'history';

export enum ClickableTileMood {
    NEUTRAL,
    GOOD,
    BAD,
    WARN
}

export class ClickableTileViewModel {
    action?: () => void;
    amount?: string; // '6'|'six'
    emphasizedWord?: string; // word in status string to receive color emphasis
    height: string; // '100%'|'1000px'
    history: H.History;
    leftIcon: JSX.Element;
    mood?: ClickableTileMood;
    rightIcon?: JSX.Element;
    rightText?: string;
    status?: string;
    width: string; // '100%'|'1000px'
}
